import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import COLORS from '../../constants/colors';
import img1 from '../../assets/11.png';
import img2 from '../../assets/12.png';
import img3 from '../../assets/13.png';
import img4 from '../../assets/14.png';
import img5 from '../../assets/15.png';
import img6 from '../../assets/16.png';
import img7 from '../../assets/17.png';
import img8 from '../../assets/18.png';
import img9 from '../../assets/19.png';
import img10 from '../../assets/20.png';


// Desktop Images
import depoImg from "../../assets/newServiceImg/new-desk-depo-lawsuit.png";
import paraquatImg from "../../assets/newServiceImg/new-desk-paraquat-lawsuit.png";
import roundupImg from "../../assets/newServiceImg/new-desk-roundup-lawsuit.png";
import babyFoodImg from "../../assets/newServiceImg/new-desk-toxic-baby-food-lawsuit.png";
import oxbrytaImg from "../../assets/newServiceImg/new-desk-oxbryta-lawsuit.png";
import talcumImg from "../../assets/newServiceImg/new-desk-talcum-powder-lawsuit.png";
import bardImg from "../../assets/newServiceImg/new-desk-bard-powerport-lawsuit.png";
import afffImg from "../../assets/newServiceImg/new-desk-afff-firefighting-foam-lawsuit.png";
import pfasImg from "../../assets/newServiceImg/new-desk-pfas-contamination-lawsuit.png";
import meshImg from "../../assets/newServiceImg/new-desk-transvaginal-mesh-lawsuit.png";
 
// Mobile Images
import depoImgMob from "../../assets/SubserviceMobile/mob-depo-provera-lawsuit.png";
import paraquatImgMob from "../../assets/SubserviceMobile/mob-paraquat-lawsuit.png";
import roundupImgMob from "../../assets/SubserviceMobile/mob-roundup-lawsuit.png";
import babyFoodImgMob from "../../assets/SubserviceMobile/mob-toxic-baby-food-lawsuit.png";
import oxbrytaImgMob from "../../assets/SubserviceMobile/mob-oxbryta-lawsuit.png";
import talcumImgMob from "../../assets/SubserviceMobile/mob-talcum-powder-lawsuit.png";
import bardImgMob from "../../assets/SubserviceMobile/mob-bard-powerport-lawsuit.png";
import afffImgMob from "../../assets/SubserviceMobile/mob-afff-firefighting-foam-lawsuit.png";
import pfasImgMob from "../../assets/SubserviceMobile/mob-pfas-contamination-lawsuit.png";
import meshImgMob from "../../assets/SubserviceMobile/mob-transvaginal-mesh-lawsuit.png";
 
const lawsuits = [
  { title: 'Depo-Provera Lawsuit', description: 'Linked to brain tumors and bone loss in long-term users', image: img1, link: '/DepoMain' },
  { title: 'Paraquat Lawsuit', description: 'Parkinsons disease caused by toxic herbicide exposure', image: img2, link: '/ParaquatMain' },
  { title: 'Roundup Lawsuit', description: 'Cancer linked to glyphosate-based weed killer', image: img3, link: '/roundupMain' },
  { title: 'Toxic Baby Food Lawsuit', description: 'Heavy metal exposure tied to developmental delays', image: img4, link: '/Babyfood' },
  { title: 'Oxbryta Lawsuit', description: 'Linked to brain tumors and bone loss in long-term users', image: img5, link: '/OxbrytaMain' },
  { title: 'Talcum Powder Lawsuit', description: 'Parkinsons disease caused by toxic herbicide exposure', image: img6, link: '/TalcumMain' },
  { title: 'Bard PowerPort Lawsuit', description: 'Cancer linked to glyphosate-based weed killer', image: img7, link: '/BardPowerPortMain' },
  { title: 'AFFF Firefighting Foam Lawsuit', description: 'Linked to brain tumors and bone loss in long-term users', image: img8, link: '/AFFFMain' },
  { title: 'PFAS Contamination Lawsuit', description: 'Parkinsons disease caused by toxic herbicide exposure', image: img9, link: '/PFASMain' },
  { title: 'Transvaginal Mesh Lawsuit', description: 'Cancer linked to glyphosate-based weed killer', image: img10, link: '/TransvaginalMain' },
];
 
const Moblawsuits = [
  { title: 'Depo-Provera Lawsuit', description: 'Linked to brain tumors and bone loss in long-term users', image: img1, link: '/DepoMain' },
  { title: 'Paraquat Lawsuit', description: 'Parkinsons disease caused by toxic herbicide exposure', image: img2, link: '/ParaquatMain' },
  { title: 'Roundup Lawsuit', description: 'Cancer linked to glyphosate-based weed killer', image: img3, link: '/roundupMain' },
  { title: 'Toxic Baby Food Lawsuit', description: 'Heavy metal exposure tied to developmental delays', image: img4, link: '/Babyfood' },
  { title: 'Oxbryta Lawsuit', description: 'Linked to brain tumors and bone loss in long-term users', image: img5, link: '/OxbrytaMain' },
  { title: 'Talcum Powder Lawsuit', description: 'Parkinsons disease caused by toxic herbicide exposure', image: img6, link: '/TalcumMain' },
  { title: 'Bard PowerPort Lawsuit', description: 'Cancer linked to glyphosate-based weed killer', image: img7, link: '/BardPowerPortMain' },
  { title: 'AFFF Firefighting Foam Lawsuit', description: 'Linked to brain tumors and bone loss in long-term users', image: img8, link: '/AFFFMain' },
  { title: 'PFAS Contamination Lawsuit', description: 'Parkinsons disease caused by toxic herbicide exposure', image: img9, link: '/PFASMain' },
  { title: 'Transvaginal Mesh Lawsuit', description: 'Cancer linked to glyphosate-based weed killer', image: img10, link: '/TransvaginalMain' },
];
 
const ServiceThree = () => {
  const [isMobile, setIsMobile] = useState(false);
 
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
 
  return (
    <section className="px-4 sm:px-8 md:px-16 lg:px-24 py-12 bg-white w-full font-[Quicksand]">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="mb-8">
          <h2 style={{color: COLORS.darkBlue}} className="text-2xl md:text-3xl font-semibold">
            What Do We <span className="text-[#BB9E50]">Help You</span> With?
          </h2>
        </div>
 
        {isMobile ? (
          <div className="grid grid-cols-2 gap-6">
            {Moblawsuits.map((item, idx) => (
              <div key={idx} className="bg-white rounded-[14px] overflow-hidden w-full">
                <div className="w-full h-[180px] overflow-hidden relative">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-fill rounded-[10%]"
                  />
                  <div className="absolute bottom-0 left-0 w-full text-left px-3 py-3">
                    <h3 className="text-[14px] sm:text-[13px] font-bold text-white leading-tight px-3 py-2 break-words whitespace-normal">
                      {item.title}
                    </h3>
                  </div>
                </div>
                <div className="p-4">
                  <p className="text-sm text-[#6b7280] leading-snug">{item.description}</p>
                  <Link to={item.link}>
                    <button className="mt-4 px-4 py-2 border border-blue-600 text-blue-600 rounded-[6px] text-sm transition-colors duration-200 hover:bg-yellow-400">
                      Learn More
                    </button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-6">
            {lawsuits.map((item, idx) => (
              <div key={idx} className="bg-white rounded-[14px] overflow-hidden w-full max-w-[300px] mx-auto">
                <div className="w-full h-[180px] overflow-hidden relative">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-fill"
                  />
                  <div className="absolute bottom-0 left-0 w-full text-left px-4 py-3">
                    <h3 className="text-[16px] font-bold text-white leading-tight px-3 py-2 break-words whitespace-normal">
                      {item.title}
                    </h3>
                  </div>
                </div>
                <div className="p-4">
                  <p className="text-sm text-[#6b7280] leading-snug mb-4">
                    {item.description}
                  </p>
                  <Link to={item.link}>
                    <button className="mt-2 px-4 py-2 border border-blue-600 text-blue-600 rounded-[6px] text-sm transition-colors duration-200 hover:bg-yellow-400">
                      Learn More
                    </button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
 
export default ServiceThree;
 
 